(function($, undefined) {
	'use strict';
	var utils;
	var formValidator;
	var locationsUtils;
	var addUserForm;
	var newUsersList;
	var currentUsersList;
	
	var init = function() {
		utils = Fw.component.models().utils;
		formValidator = Fw.component.models().form;
		locationsUtils = Fw.component.models().locationsUtils;
		
		addUserForm = $('.add-location-user-form');
		newUsersList = $('#new-location-users-list');
		currentUsersList = $('#current-location-users-list');
		
		$('#add-new-location-user-form-btn').on('click', onAddNewUserSubmitBtnClick);
		$('#location-form-users-existing-user-input').on('change', onSelectExistingUser);
		$('button.submit-location-users-form').on('click', submitLocationUsersForm);
		
		$('body').on('location-user-removed', (e, personId, name, roleText) => {
			reAddExistingUserInSelect(personId, name, roleText);
		});
	};
	
	var onAddNewUserSubmitBtnClick = function() {
		formValidator.validateForm(addUserForm);	
		$('.form-message.user-already-exists', addUserForm).hide();
		// Check password match
		const passwordValid = formValidator.validatePasswordRestrictions($('[name=password]', addUserForm).val());	
		if(!passwordValid) {
			addUserForm.addClass('has-error');
			$('[name=password]', addUserForm).addClass('error');
		}		
		if (!addUserForm.hasClass('has-error')) {
			var data = $('input, select', addUserForm).formData();
			data["curPage"]=location.pathname;
			utils.createPerson(data, (personId) => {
				if (personId !== -1) {
					var roleText = $('#add-user-form-role-input', addUserForm).find("option[value=" + data.field1 + "]").text();
					
					appendNewUserItem(data.firstName + " " + data.lastName, roleText, personId, true, data.field1);
					
					$('input, select', addUserForm).not('[type=hidden]').val("");
				}
				else {
					$('.form-message.user-already-exists', addUserForm).slideDown(300);
				}
			});
		}
	};
	
	var onSelectExistingUser = function() {
		var t = $(this);
		var selectedOption = $('option:selected', t);
		
		var personId = t.val();
		var name = selectedOption.text().split(" - ")[0];
		var roleText = selectedOption.text().split(" - ")[1];
		var role = selectedOption.attr('data-role');
		var existingField7 = selectedOption.attr('data-field7');
		
		// Treat selected-existing users the same as inline-created users:
		// flag as new-user so their role-based button-access defaults get
		// applied on save. Carry existing field7 so we MERGE the new
		// location entry instead of wiping access for other locations.
		appendNewUserItem(name, roleText, personId, true, role, existingField7);
		selectedOption.remove();
	};
	
	var appendNewUserItem = function(name, roleText, personId, isNewUser = false, role, existingField7) {
		var item = $('.location-form-editable-list-item.template', newUsersList).clone(true);
		item.removeClass("template");
		$('.location-form-editable-list-item__content', item).find("strong").text(name);
		$('.location-form-editable-list-item__content', item).find("span").text(roleText);
		if (isNewUser) {
			item.attr("data-is-new-user", "true");
			if (role !== undefined && role !== null && String(role).length > 0) {
				item.attr("data-role", String(role));
			}
			if (existingField7 !== undefined && existingField7 !== null && String(existingField7).length > 0) {
				// Store via jQuery .data() to avoid HTML-attribute quoting issues with JSON.
				item.data("existingField7", String(existingField7));
			}
		}
		item.find('.location-form-editable-list-item__btn_delete').attr("data-item-id", personId);
		item.find('.location-form-editable-list-item__btn_delete').attr("data-name", name);
		item.find('.location-form-editable-list-item__btn_delete').attr("data-role-text", roleText);
		item.attr("data-id", "location-editable-item-" + personId);
		item.attr("data-item-id", personId);
		newUsersList.append(item);
	};
	
	var gatherUserIds = function() {
		var usersList = [];
		// if ($('[name=locationCreatorId]').val().length > 0) {
		// 	usersList.push($('[name=locationCreatorId]').val());
		// }
		$('.location-form-editable-list-item:not(.template)', currentUsersList).each((i, item) => {
			usersList.push($(item).attr("data-item-id"));
		});
		$('.location-form-editable-list-item:not(.template)', newUsersList).each((i, item) => {
			usersList.push($(item).attr("data-item-id"));
		});
		return usersList.filter(item => item && !isNaN(parseInt(item)) && item.length > 0).join();
	};
	
	var reAddExistingUserInSelect = function(personId, name, roleText) {
		var option = $(`<option value="${personId}">${name} - ${roleText}</option>`);
		option.insertAfter($('#location-form-users-existing-user-input').find('option[value=""]'));
	};
	
	function submitLocationUsersForm ({currentTarget}) {
		var $btn = $(currentTarget);
		var $form = $btn.closest('.location-form-content');
		var userIds = gatherUserIds();
		
		locationsUtils.hideMessage($form, '');
		
		if (userIds.length > 0) {
			locationsUtils.addOverlay();

			// Capture the personIds of users that were just created from
			// the inline "Add user" sub-form on this page. Those rows are
			// marked with data-is-new-user="true". We need them BEFORE the
			// success handler moves the elements over to the current list.
			var newUserEntries = newUsersList
				.find('.location-form-editable-list-item[data-is-new-user="true"]:not(.template)')
				.map((i, el) => ({
					personId: $(el).attr('data-item-id'),
					role: $(el).attr('data-role'),
					existingField7: $(el).data('existingField7')
				}))
				.get()
				.filter(entry => entry.personId && !isNaN(parseInt(entry.personId)));

			locationsUtils.createOrUpdateLocation(["id", "field10"], [$form.find('[name="id"]').val(), userIds], (id) => {
				if (id != null) {
					$form.find('[name="id"]').val(id);
					locationsUtils.showMessage($form, '_success');
					newUsersList.find('.location-form-editable-list-item:not(.template)').each((i, el) => {
						$(el).removeClass('location-form-editable-list-item_full').appendTo(currentUsersList);
					});

					// For users CREATED from this form, default both
					// "Access to property buttons" and "Access to security
					// buttons" to checked for this location. The add-user
					// page reads these from person.field7, a JSON map keyed
					// by locationId: { ids, all, allProperty, allSecurity }.
					grantAllButtonAccessForNewUsers(newUserEntries, id);
				} else {
					locationsUtils.showMessage($form, '_server');
				}
				locationsUtils.removeOverlay();
			});
		} 
		else {
			locationsUtils.showMessage($form, '_fields');
		}
	};

	function grantAllButtonAccessForNewUsers(entries, locationId) {
		if (!entries || entries.length === 0 || !locationId) {
			return;
		}

		// Default button-access per role (person.field1, addInfo1):
		//   "1" Manager          -> Property buttons only
		//   "3" User             -> Property buttons only
		//   "6" Security Manager -> Security buttons only
		//   "7" Security User    -> Security buttons only
		// Any other role: skip (leave field7 empty).
		var getFlagsForRole = function(role) {
			switch (String(role)) {
				case "1":
				case "3":
					return { allProperty: true, allSecurity: false };
				case "6":
				case "7":
					return { allProperty: false, allSecurity: true };
				default:
					return null;
			}
		};

		entries.forEach((entry) => {
			var flags = getFlagsForRole(entry.role);
			if (!flags) {
				return;
			}
			// Start from the user's existing field7 map (if any) so we don't
			// wipe access entries for OTHER locations. New users have no
			// existingField7 and start from an empty map.
			var accessMap = {};
			if (entry.existingField7) {
				try {
					var parsed = JSON.parse(entry.existingField7);
					if (parsed && typeof parsed === 'object') {
						accessMap = parsed;
					}
				} catch (e) {
					accessMap = {};
				}
			}
			accessMap[locationId] = {
				ids: "",
				all: false,
				allProperty: flags.allProperty,
				allSecurity: flags.allSecurity
			};
			var field7Value = JSON.stringify(accessMap);

			// field7 lives on the Person row (column addInfo7), so we
			// must hit /action/updatePerson, NOT /action/manageGenData
			// (manageGenData would treat personId as a GenData id and
			// corrupt an unrelated row — e.g. a location).
			utils.updatePersonFields(["field7"], [field7Value], entry.personId);
		});
	}
	

	

	$(window).ready(function() {
		init();
	});
})(jQuery);
